import type { SpinProps } from "antd";
import { Spin } from "antd";
import type { FC } from "react";

export type IotSpinProps = SpinProps;

export const IotSpin: FC<IotSpinProps> = (props) => <Spin {...props} />;
